export interface SportCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
}

export interface SportEvent {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  time: string;
  team1: string;
  team2: string;
  team1Logo: string;
  team2Logo: string;
  status: 'upcoming' | 'live' | 'finished';
  score?: string;
  league: string;
}

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  image: string;
  tags: string[];
  readTime: string;
  featured?: boolean;
}

export const sportCategories: SportCategory[] = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '汇聚全球顶级足球赛事，英超、西甲、欧冠等精彩对决一网打尽，实时比分与深度分析助您掌握赛场动态。',
    articleCount: 48,
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA等顶级篮球联赛全程追踪，球星动态、战术分析、赛事预测，篮球迷的终极资讯平台。',
    articleCount: 36,
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    description: '四大满贯、ATP、WTA巡回赛全面覆盖，专业网球评论与赛事前瞻，带您领略网球运动的优雅与激情。',
    articleCount: 24,
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: '英雄联盟、DOTA2、CS2等顶级电竞赛事资讯，战队排名、选手数据、赛事直播一应俱全。',
    articleCount: 32,
  },
  {
    slug: 'racing',
    name: '赛车',
    icon: 'ri-steering-2-line',
    description: 'F1方程式、MotoGP、WRC拉力赛等顶级赛车运动，速度与激情的完美碰撞，赛道内外精彩故事。',
    articleCount: 18,
  },
  {
    slug: 'boxing',
    name: '搏击',
    icon: 'ri-boxing-line',
    description: 'UFC、拳击、自由搏击等格斗赛事全面追踪，拳手专访、赛前称重、精彩KO瞬间不容错过。',
    articleCount: 20,
  },
];

export const sportEvents: SportEvent[] = [
  {
    id: 'evt-001',
    title: '英超第3轮焦点战',
    category: '足球',
    categorySlug: 'football',
    date: '2026-08-12',
    time: '22:00',
    team1: '曼城',
    team2: '阿森纳',
    team1Logo: 'https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20crest%20logo%20sky%20blue%20and%20white%20minimalist%20design%20on%20clean%20white%20background&width=200&height=200&seq=team-mancity&orientation=squarish',
    team2Logo: 'https://readdy.ai/api/search-image?query=Arsenal%20football%20club%20crest%20logo%20red%20and%20white%20minimalist%20design%20on%20clean%20white%20background&width=200&height=200&seq=team-arsenal&orientation=squarish',
    status: 'upcoming',
    league: '英超联赛',
  },
  {
    id: 'evt-002',
    title: 'NBA常规赛',
    category: '篮球',
    categorySlug: 'basketball',
    date: '2026-08-11',
    time: '10:30',
    team1: '湖人',
    team2: '凯尔特人',
    team1Logo: 'https://readdy.ai/api/search-image?query=Los%20Angeles%20Lakers%20basketball%20team%20logo%20purple%20and%20gold%20minimalist%20design%20on%20clean%20white%20background&width=200&height=200&seq=team-lakers&orientation=squarish',
    team2Logo: 'https://readdy.ai/api/search-image?query=Boston%20Celtics%20basketball%20team%20logo%20green%20and%20white%20minimalist%20design%20on%20clean%20white%20background&width=200&height=200&seq=team-celtics&orientation=squarish',
    status: 'live',
    score: '87:82',
    league: 'NBA',
  },
  {
    id: 'evt-003',
    title: '温网男单半决赛',
    category: '网球',
    categorySlug: 'tennis',
    date: '2026-08-10',
    time: '18:00',
    team1: '阿尔卡拉斯',
    team2: '德约科维奇',
    team1Logo: 'https://readdy.ai/api/search-image?query=Carlos%20Alcaraz%20tennis%20player%20Spanish%20flag%20inspired%20minimalist%20icon%20on%20clean%20white%20background&width=200&height=200&seq=player-alcaraz&orientation=squarish',
    team2Logo: 'https://readdy.ai/api/search-image?query=Novak%20Djokovic%20tennis%20player%20Serbian%20flag%20inspired%20minimalist%20icon%20on%20clean%20white%20background&width=200&height=200&seq=player-djokovic&orientation=squarish',
    status: 'finished',
    score: '3:1',
    league: '温布尔登网球锦标赛',
  },
  {
    id: 'evt-004',
    title: 'LPL夏季赛决赛',
    category: '电竞',
    categorySlug: 'esports',
    date: '2026-08-15',
    time: '17:00',
    team1: 'JDG',
    team2: 'BLG',
    team1Logo: 'https://readdy.ai/api/search-image?query=JDG%20esports%20team%20logo%20red%20and%20black%20minimalist%20gaming%20design%20on%20clean%20white%20background&width=200&height=200&seq=team-jdg&orientation=squarish',
    team2Logo: 'https://readdy.ai/api/search-image?query=BLG%20esports%20team%20logo%20blue%20and%20white%20minimalist%20gaming%20design%20on%20clean%20white%20background&width=200&height=200&seq=team-blg&orientation=squarish',
    status: 'upcoming',
    league: 'LPL英雄联盟职业联赛',
  },
  {
    id: 'evt-005',
    title: 'F1意大利大奖赛',
    category: '赛车',
    categorySlug: 'racing',
    date: '2026-08-20',
    time: '21:00',
    team1: '维斯塔潘',
    team2: '汉密尔顿',
    team1Logo: 'https://readdy.ai/api/search-image?query=Max%20Verstappen%20red%20bull%20racing%20driver%20minimalist%20icon%20on%20clean%20white%20background&width=200&height=200&seq=driver-verstappen&orientation=squarish',
    team2Logo: 'https://readdy.ai/api/search-image?query=Lewis%20Hamilton%20mercedes%20racing%20driver%20minimalist%20icon%20on%20clean%20white%20background&width=200&height=200&seq=driver-hamilton&orientation=squarish',
    status: 'upcoming',
    league: 'F1世界一级方程式锦标赛',
  },
  {
    id: 'evt-006',
    title: 'UFC格斗之夜',
    category: '搏击',
    categorySlug: 'boxing',
    date: '2026-08-18',
    time: '11:00',
    team1: '张伟丽',
    team2: '罗斯',
    team1Logo: 'https://readdy.ai/api/search-image?query=Chinese%20female%20MMA%20fighter%20minimalist%20icon%20red%20and%20gold%20on%20clean%20white%20background&width=200&height=200&seq=fighter-weili&orientation=squarish',
    team2Logo: 'https://readdy.ai/api/search-image?query=American%20female%20MMA%20fighter%20minimalist%20icon%20on%20clean%20white%20background&width=200&height=200&seq=fighter-rose&orientation=squarish',
    status: 'upcoming',
    league: 'UFC终极格斗冠军赛',
  },
];

export const articles: Article[] = [
  {
    slug: 'premier-league-roundup-week-3',
    title: '英超第三轮综述：曼城逆转取胜，阿森纳客场告捷',
    excerpt: '英超联赛第三轮战罢，曼城在落后一球的情况下连扳三球逆转取胜，继续领跑积分榜。阿森纳客场2-0轻取对手，紧追不舍。',
    content: `<p>英超联赛第三轮比赛于上周末全面展开，多场焦点对决精彩纷呈。卫冕冠军曼城在主场迎战劲敌的比赛中展现了强大的韧性和实力。</p>
<p>比赛开始后，客队率先发难，在第15分钟通过一次快速反击率先破门。落后的曼城并未慌乱，凭借德布劳内精准的组织和哈兰德强大的终结能力，在上半场结束前就将比分扳平。</p>
<p>下半场，曼城完全掌控了比赛节奏。第62分钟，福登在禁区外一脚远射直挂死角，帮助球队反超比分。第78分钟，哈兰德接队友传中头球破门，锁定胜局。</p>
<p>与此同时，阿森纳客场挑战升班马的比赛中，凭借萨卡和厄德高的进球，以2-0轻松取胜。枪手新赛季开局三连胜，展现出了争冠的实力。</p>
<p>在其他场次中，利物浦主场3-1击败对手，切尔西客场1-1战平，热刺则在主场4-0大胜。积分榜上，曼城、阿森纳和利物浦暂列前三。</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '体育编辑部',
    date: '2026-08-08',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20professional%20football%20soccer%20match%20action%20scene%20with%20players%20on%20green%20field%20under%20stadium%20lights%20at%20night%20dramatic%20atmosphere%20sports%20photography%20style&width=1200&height=600&seq=article-football-01&orientation=landscape',
    tags: ['英超', '曼城', '阿森纳', '赛事综述'],
    readTime: '8分钟',
    featured: true,
  },
  {
    slug: 'nba-trade-rumors-summer',
    title: 'NBA休赛期交易流言汇总：多支球队酝酿重磅交易',
    excerpt: 'NBA休赛期交易市场暗流涌动，多位全明星球员卷入交易流言。湖人、凯尔特人等豪门球队积极寻求补强，新赛季格局或将重塑。',
    content: `<p>随着NBA选秀大会落下帷幕，自由球员市场即将开启，联盟各支球队已经开始紧锣密鼓地筹备新赛季的阵容调整。</p>
<p>据多家美国媒体报道，湖人队正在积极寻求通过交易获得一名全明星级别的控卫，以减轻詹姆斯的组织压力。消息人士透露，湖人队已经与多支球队进行了初步接触，交易方案涉及多个首轮选秀权和年轻球员。</p>
<p>凯尔特人方面，虽然球队上赛季表现不俗，但管理层仍在寻求提升阵容深度。有消息称，凯尔特人对一名西部球队的锋线球员表现出了浓厚兴趣。</p>
<p>此外，76人队、热火队和太阳队也在积极运作，试图通过交易或自由签约增强球队竞争力。随着新劳资协议的实施，各队在进行交易时需要考虑更多的薪资空间限制。</p>
<p>专家分析认为，今年的休赛期将比往年更加活跃，多笔重磅交易可能在选秀夜前后完成。球迷们可以期待一个充满变化的夏天。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    author: '篮球评论组',
    date: '2026-08-07',
    image: 'https://readdy.ai/api/search-image?query=Professional%20NBA%20basketball%20arena%20atmosphere%20with%20dramatic%20lighting%20court%20view%20orange%20and%20dark%20tones%20sports%20photography%20aesthetic&width=1200&height=600&seq=article-basketball-01&orientation=landscape',
    tags: ['NBA', '交易流言', '湖人', '凯尔特人'],
    readTime: '6分钟',
  },
  {
    slug: 'wimbledon-mens-final-preview',
    title: '温网男单决赛前瞻：新老天王巅峰对决引爆全英俱乐部',
    excerpt: '温布尔登网球锦标赛男单决赛即将上演，新科世界第一阿尔卡拉斯迎战七冠王德约科维奇，这场世代交替之战吸引了全球目光。',
    content: `<p>温布尔登网球锦标赛男单决赛将于北京时间今晚21:00在全英俱乐部中心球场打响，西班牙新星阿尔卡拉斯将与塞尔维亚天王德约科维奇争夺挑战者杯。</p>
<p>年仅23岁的阿尔卡拉斯本赛季状态火热，已经斩获两个大满贯冠军。他的打法全面，正手极具攻击性，移动能力出色。在半决赛中，阿尔卡拉斯直落三盘击败对手，展现出了极佳的竞技状态。</p>
<p>而36岁的德约科维奇依然是草地之王，他在温网已经七次夺冠，对这片场地有着超乎常人的掌控力。本届赛事中，德约科维奇一路过关斩将，除了四分之一决赛丢掉一盘外，其余比赛均轻松取胜。</p>
<p>两人此前交手6次，德约科维奇以4胜2负占据优势。但最近两次交手均是阿尔卡拉斯获胜，包括今年法网半决赛的一场五盘大战。</p>
<p>这场决赛不仅是两位顶尖选手之间的较量，更可能成为男子网坛世代交替的标志性时刻。无论结果如何，球迷们都将见证一场精彩绝伦的对决。</p>`,
    category: '网球',
    categorySlug: 'tennis',
    author: '网球特约记者',
    date: '2026-08-06',
    image: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20championship%20grass%20court%20center%20court%20aerial%20view%20elegant%20green%20and%20white%20atmosphere%20prestigious%20sports%20venue%20photography&width=1200&height=600&seq=article-tennis-01&orientation=landscape',
    tags: ['温网', '阿尔卡拉斯', '德约科维奇', '决赛'],
    readTime: '7分钟',
    featured: true,
  },
  {
    slug: 'lpl-summer-finals-jdg-blg',
    title: 'LPL夏季赛决赛前瞻：JDG与BLG的宿命对决',
    excerpt: 'LPL夏季赛总决赛即将开战，常规赛第一JDG对阵季后赛黑马BLG。两支战队在整个赛季中交手三次，JDG以2胜1负略占优势。',
    content: `<p>经过三个月的激烈角逐，LPL夏季赛终于迎来了最终决战。JDG和BLG两支顶级战队将在决赛舞台上一决高下，争夺夏季赛冠军和世界赛一号种子资格。</p>
<p>JDG作为常规赛冠军，展现出了碾压级别的统治力。上单369状态火热，中单Knight发挥稳定，下路Ruler和Missing的组合默契十足。在半决赛中，JDG以3-0的比分轻松横扫对手，进入决赛。</p>
<p>BLG则是本赛季最大的惊喜，他们在季后赛中一路从败者组杀出，连续击败多支强队，展现出了极强的韧性和应变能力。打野Xun的发挥尤为关键，他的野区控制和Gank节奏是BLG取胜的重要保障。</p>
<p>两支队伍在本赛季交手三次——春季赛决赛BLG获胜，夏季赛常规赛JDG双杀BLG。这次决赛是两队本赛季的第四次交锋，也是最重要的一次。</p>
<p>无论谁获胜，都将代表LPL赛区以一号种子的身份出征今年的全球总决赛。这场巅峰对决，不容错过。</p>`,
    category: '电竞',
    categorySlug: 'esports',
    author: '电竞频道',
    date: '2026-08-05',
    image: 'https://readdy.ai/api/search-image?query=Grand%20esports%20arena%20stadium%20with%20massive%20LED%20screens%20purple%20and%20blue%20dramatic%20lighting%20packed%20crowd%20professional%20gaming%20event%20atmosphere&width=1200&height=600&seq=article-esports-01&orientation=landscape',
    tags: ['LPL', 'JDG', 'BLG', '英雄联盟'],
    readTime: '5分钟',
  },
  {
    slug: 'f1-italian-gp-preview',
    title: 'F1意大利大奖赛：蒙扎赛道速度与激情的终极考验',
    excerpt: 'F1赛历中最具传奇色彩的蒙扎赛道即将迎来意大利大奖赛，维斯塔潘能否延续连胜纪录？法拉利主场作战备受期待。',
    content: `<p>F1世界一级方程式锦标赛本周末将来到意大利蒙扎赛道，这座被称为"速度圣殿"的传奇赛道将举办第76届意大利大奖赛。</p>
<p>蒙扎赛道以其高速特性闻名于世，是F1赛历中平均速度最快的赛道之一。长达1.1公里的大直道让赛车可以达到超过350公里/小时的极速，对引擎和刹车系统都是严峻的考验。</p>
<p>卫冕冠军维斯塔潘本赛季状态依旧火热，已经连续获得多站比赛胜利。红牛车队的RB22赛车在高速赛道上的表现尤为出色，这使得维斯塔潘成为本站比赛的最大热门。</p>
<p>法拉利车队本站迎来主场作战，热情的Tifosi（法拉利车迷）将把蒙扎变成一片红色的海洋。勒克莱尔和塞恩斯都期待着在家乡父老面前取得好成绩。</p>
<p>梅赛德斯车队近期表现回暖，汉密尔顿和拉塞尔都对蒙扎赛道有着美好的回忆。本站比赛的竞争格局将非常开放，多支车队都有机会冲击领奖台。</p>`,
    category: '赛车',
    categorySlug: 'racing',
    author: '赛车频道',
    date: '2026-08-04',
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20racing%20car%20speeding%20on%20Monza%20circuit%20with%20motion%20blur%20red%20Ferrari%20car%20dramatic%20racing%20atmosphere%20professional%20motorsport%20photography&width=1200&height=600&seq=article-f1-01&orientation=landscape',
    tags: ['F1', '蒙扎', '法拉利', '维斯塔潘'],
    readTime: '6分钟',
  },
  {
    slug: 'ufc-fight-night-weili-analysis',
    title: '张伟丽卫冕战深度解析：从数据看冠军的统治力',
    excerpt: 'UFC女子草量级冠军张伟丽即将迎来自己的第三次卫冕战。通过详尽的比赛数据分析，我们来看看这位中国女将的制胜之道。',
    content: `<p>北京时间下周日，UFC女子草量级冠军张伟丽将在拉斯维加斯T-Mobile竞技场迎来自己的第三次卫冕战。对手是来自美国的前冠军罗斯·娜玛尤纳斯。</p>
<p>从数据层面来看，张伟丽在近两年的比赛中展现出了令人惊叹的进化。她的每分钟有效打击数从早期的5.2提升到了7.8，打击防御率也从55%提升到了68%。这些数据在草量级中均排名第一。</p>
<p>摔跤方面，张伟丽的摔倒防御率达到惊人的82%，这意味着对手很难将她带入地面。同时她的地面控制时间也在稳步增长，展示出了全面的技术进化。</p>
<p>心理层面，张伟丽在赛前采访中表现出了前所未有的自信和冷静。"我已经准备好了，这将是属于我的夜晚。"她简短有力的发言让粉丝们充满期待。</p>
<p>这场卫冕战不仅是两位顶尖选手之间的较量，更是中国综合格斗运动发展的一个重要里程碑。让我们共同期待张伟丽再次创造历史。</p>`,
    category: '搏击',
    categorySlug: 'boxing',
    author: '格斗特约评论',
    date: '2026-08-03',
    image: 'https://readdy.ai/api/search-image?query=UFC%20octagon%20arena%20with%20dramatic%20spotlight%20female%20fighter%20silhouette%20red%20and%20gold%20atmosphere%20professional%20MMA%20event%20photography%20epic%20composition&width=1200&height=600&seq=article-ufc-01&orientation=landscape',
    tags: ['UFC', '张伟丽', '综合格斗', '卫冕战'],
    readTime: '7分钟',
    featured: true,
  },
  {
    slug: 'chinese-super-league-roundup',
    title: '中超联赛半程总结：争冠格局初现，保级大战白热化',
    excerpt: '中超联赛赛程过半，争冠集团和保级军团逐渐明朗。上海海港、山东泰山和武汉三镇组成争冠第一集团，积分差距仅在3分之内。',
    content: `<p>2026赛季中超联赛已经完成15轮比赛，赛程过半。纵观整个上半程，联赛展现出了竞争激烈、精彩纷呈的特点。</p>
<p>争冠方面，上海海港、山东泰山和武汉三镇形成了三足鼎立之势。上海海港凭借稳定的发挥和外援的出色表现暂居榜首，但领先优势仅有2分。山东泰山在换帅后状态回升，连续6轮不败。武汉三镇则依靠强大的主场战绩紧追不舍。</p>
<p>保级大战同样扣人心弦。目前有5支球队被困在降级区边缘，积分差距最多仅有5分。每轮比赛都可能改变保级形势，悬念将持续到最后一刻。</p>
<p>球员方面，上海海港的巴西外援以12粒进球领跑射手榜，山东泰山的本土前锋以8球紧随其后。本土球员的整体表现可圈可点，多名年轻球员展现出了不俗的潜力。</p>
<p>下半程联赛将于8月15日重燃战火，届时争冠与保级的战况将更加激烈。球迷们可以期待一个精彩纷呈的下半赛季。</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '中超特约记者',
    date: '2026-08-02',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Super%20League%20football%20stadium%20packed%20with%20passionate%20fans%20red%20banners%20dramatic%20night%20match%20atmosphere%20professional%20sports%20photography&width=1200&height=600&seq=article-csl-01&orientation=landscape',
    tags: ['中超', '上海海港', '山东泰山', '半程总结'],
    readTime: '5分钟',
  },
  {
    slug: 'esports-worlds-2026-preview',
    title: '英雄联盟S16全球总决赛：LPL四队出征，剑指冠军',
    excerpt: '英雄联盟全球总决赛即将拉开帷幕，LPL赛区四支代表队已完成集结。JDG、BLG、TES和WBG将代表中国出征，力争卫冕冠军荣耀。',
    content: `<p>随着各大赛区夏季赛的落幕，英雄联盟S16全球总决赛的参赛队伍已经全部确定。来自LPL赛区的四支代表队——JDG、BLG、TES和WBG已经整装待发。</p>
<p>作为上届冠军赛区，LPL在本届比赛中备受期待。一号种子JDG是今年最强的战队之一，他们在LPL夏季赛中展现出了统治级的表现。二号种子BLG同样实力不俗，在季后赛中展现出了极强的韧性。</p>
<p>本届全球总决赛将在韩国举行，从入围赛到决赛将跨越首尔、釜山和仁川三个城市。韩国作为电竞强国，将为本届赛事提供一流的场馆和热情的观众。</p>
<p>LCK赛区的T1、GEN等传统强队将是LPL队伍的最大竞争对手。此外，LEC和LCS赛区的队伍也不容小觑，他们在本赛季都展现出了明显的进步。</p>
<p>距离全球总决赛开幕还有一个月的时间，各支队伍将利用这段时间进行最后的备战。LPL加油，让我们期待中国队再次捧起召唤师奖杯！</p>`,
    category: '电竞',
    categorySlug: 'esports',
    author: '电竞频道',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20world%20championship%20grand%20arena%20massive%20crowd%20dramatic%20stage%20lighting%20esports%20event%20epic%20atmosphere%20professional%20gaming%20photography&width=1200&height=600&seq=article-esports-02&orientation=landscape',
    tags: ['英雄联盟', '全球总决赛', 'LPL', 'JDG'],
    readTime: '6分钟',
  },
];

export const allArticles = articles;

export const featuredArticles = articles.filter(a => a.featured);

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter(a => a.categorySlug === slug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(a => a.slug === slug);
}

export function getCategoryBySlug(slug: string): SportCategory | undefined {
  return sportCategories.find(c => c.slug === slug);
}